module.exports = __webpack_public_path__ + "img/rongyu1.d448f24d.jpeg";